import React from 'react';
import { Button, Container, Typography, Box } from '@mui/material';
import { Formik, Form } from 'formik';
import { loginValidationSchema } from '../../validationSchema/loginValidationSchema';
import { TextInput } from '../shared/textInput/textInput';
import PersonIcon from '@mui/icons-material/Person';

interface LoginFormProps {
  email: string;
  password: string;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  handleLogin: (email: string, password: string) => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ handleLogin }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container
        maxWidth="xs"
        sx={{
          background: 'rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(8px)',
          borderRadius: '16px',
          padding: 4,
          boxShadow: 3,
          textAlign: 'center',
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Box
            sx={{
              width: 60,
              height: 60,
              margin: '0 auto',
              background: '#1976d2',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h5" color="white" display="flex" alignItems="center" gap={1}>
              <PersonIcon />
            </Typography>
          </Box>
          <Typography variant="h5" fontWeight="bold" sx={{ mt: 2 }}>
            {'RankMe'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'gray', mb: 3 }}>
            {'Sign in to your account'}
          </Typography>
        </Box>

        <Formik
          initialValues={{ email: '', password: '' }}
          validationSchema={loginValidationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await handleLogin(values.email, values.password);
            } catch (error) {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, touched, errors, isValid }) => (
            <Form>
              <TextInput
                label={'Email address'}
                name="email"
                disabled={isSubmitting}
                errorText={errors.email && touched.email ? errors.email : ''}
                required
              />

              <TextInput
                label={'Password'}
                name="password"
                type="password"
                  disabled={isSubmitting}
                errorText={errors.password && touched.password ? errors.password : ''}
                required
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={isSubmitting || !isValid}
                sx={{ mb: 2 }}
              >
                {'Sign In'}
              </Button>

              <Typography variant="caption" display="block" sx={{ mt: 3, color: 'gray' }}>
                Protected by industry-standard encryption
              </Typography>
            </Form>
          )}
        </Formik>
      </Container>
    </Box>
  );
};

